/* eslint-disable linebreak-style */
import { Icon } from "@mui/material";
import { NavLink as Link } from "react-router-dom";
import styles from "./nav.module.scss";
import {
  hasPermissionWithContext,
  isActiveWithContext,
  isSuperAdmin,
} from "@/common/utils/utils";
import { getComponentValueSafe } from "@/common/utils/componentListHelper";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { IUserContextModel } from "@/store/auth/types";
import { isIntegrationSettingsVisibleWithContext } from "@/common/utils/integrationSettingConfig";
import { ComponentKeys } from "@/common/enums/enums";

function NavMenuItem({ item, index, isSideBarOpen, keyValue, to, name }: any) {
  // Call hooks at the top level
  const authContext: IUserContextModel = useSelector(
    (state: any) => state.userContext
  );
  const superAdmin = isSuperAdmin();
  const active = item.component
    ? isActiveWithContext(getComponentValueSafe(item.component), authContext)
    : false;
  const integrationSettingsVisible = item.path?.startsWith(
    "/integration-settings"
  )
    ? isIntegrationSettingsVisibleWithContext(item.path, authContext)
    : hasPermissionWithContext(
      item.path,
      authContext,
      item.isVisibleWithoutPermission
    );

  // Then memoize values if you really need memoization
  const isComponentHided = useMemo(() => {
    if (superAdmin && item.component && getComponentValueSafe(item.component) === getComponentValueSafe(ComponentKeys.CAR)) {
      return false;
    }
    if (item.component) {
      return !active;
    }
    return false;
  }, [superAdmin, active, item.component]);

  const hideIntegration = useMemo(
    () => integrationSettingsVisible,
    [integrationSettingsVisible]
  );

  if (isComponentHided || !hideIntegration) {
    return <></>;
  }

  return (
    <li className={styles.navItem} key={keyValue}>
      <Link
        data-cy={`nav-item-${item.name}`}
        to={to}
        key={index}
        className={({ isActive }) =>
          `${styles.navItemLink} ${isActive ? styles.navItemLinkActive : ""}`
        }
        onClick={() => item.onClick?.()}
      >
        <div className={styles.navItemIcon}>
          <Icon
            component={item.icon}
            sx={{ fontSize: 24 }}
            className={styles.navItemIconWidth}
          />
        </div>
        {isSideBarOpen && <div className={styles.navItemText}>{name}</div>}
      </Link>
    </li>
  );
}

export default NavMenuItem;
